<template>
  <header class="main-header">
    <span class="logo-mini">
      <a href="/admin/dashboard"><img src="/static/img/logo-emembers-white.png" alt="Logo" class="img-responsive center-block logo"></a>
    </span>
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>

      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- <messages-menu></messages-menu>
          <notifications-menu></notifications-menu>
          <tasks-menu></tasks-menu> -->
          <project-menu></project-menu>
          <user-menu :user="user"></user-menu>         
          <!-- <li>
            <span class="logo-mini">
              <img src="/static/img/logoSML.png" alt="" style="background-color:white;">
            </span>
          </li> -->
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState } from 'vuex'
// import MessagesMenu from './MessagesMenu'
// import NotificationsMenu from './NotificationsMenu'
// import TasksMenu from './TasksMenu'
import UserMenu from './UserMenu'
import ProjectMenu from './ProjectMenu'

export default {
  name: 'DashHeader',
  components: {
    // MessagesMenu,
    // NotificationsMenu,
    // TasksMenu,
    UserMenu,
    ProjectMenu
  },
  props: ['user'],
  computed: {
    ...mapState([
      'userInfo'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// DashHeader.vue?49fe3d30